import { render, staticRenderFns } from "./InsightsByProviderImpression.vue?vue&type=template&id=900a4ee4&"
import script from "./InsightsByProviderImpression.vue?vue&type=script&lang=js&"
export * from "./InsightsByProviderImpression.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports